import { v4 as uuidv4 } from 'uuid';

/**
 * Creates a unique element ID.
 * @param prefix Optional prefix for the ID. Default is 'kros'.
 * @returns Unique element ID.
 */
export function createUniqueElementId(prefix: string = 'kros'): string {
  if (window.crypto && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${window.crypto.randomUUID()}`;
  } else {
    // we don't need v7() here, v4() is sufficient for generating unique IDs for html elements
    return `${prefix}-${uuidv4()}`;
  }
}
